$(function () {

    DECIX.slider = DECIX.slider || {};

    DECIX.slider.init = function (autoPlay) {

        $(".slider>.slick-carousel")
            .slick({
                dots: true,
                arrows: false,
                prevArrow: "<button class=\"slick-prev\"></button>",
                nextArrow: "<button class=\"slick-next\"></button>",
                autoplaySpeed: 10000,
                autoplay: autoPlay,
                pauseOnDotsHover: true,
                pauseOnHover: true,
                fade: false,
                responsive: [
                    {
                        breakpoint: 1024,
                        settings: {
                            dots: true,
                            arrows: false
                        }
                    }
                ]
            });

    };

    DECIX.slider.init(true);

});
